import { render, staticRenderFns } from "./zihao.vue?vue&type=template&id=0673ca3c"
import script from "./zihao.vue?vue&type=script&lang=js"
export * from "./zihao.vue?vue&type=script&lang=js"
import style0 from "./zihao.vue?vue&type=style&index=0&id=0673ca3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports